import * as merge from 'deepmerge';
export var deepmerge = merge;
export var deepcopy = function (o) { return deepmerge({}, o); };
export var copy = deepcopy;
/**
 * Custom arrayMerge function that matches all entries from the destinationArray to the entries of the sourceArray by id.
 * If an entry from the destinationArray cannot be found in the sourceArray then it is discarded.
 *
 * This behaviour is derived from the assumption that only the sourceArray entries are relevant to the result
 * (e.g. because the value in the sourceArray was removed and therefore is no longer wanted).
 *
 * Example to illustrate:
 *
 * destinationArray: [{id: 1, ...}, {id: 2, name: x, ...}
 * sourceArray: [{id: 2, name: y, ...}]
 *
 * returnValue: [{id: 2, name: y, ...}]
 */
export function arrayMerge(destinationArray, sourceArray) {
    return sourceArray.map(function (entry) {
        var index = destinationArray.findIndex(function (a) { return a.id === entry.id; });
        var returnValue = entry;
        if (index > -1) {
            returnValue = deepmerge.all([{}, destinationArray[index], entry], {
                arrayMerge: arrayMerge,
            });
        }
        return returnValue;
    });
}
//# sourceMappingURL=deepmerge.js.map